<template>
  <DataTableCell :full-width="fullWidth">
    <v-text-field
      v-if="editMode"
      :style="{ fontSize }"
      :type="type"
      v-model="inputVal"
      full-width
      hide-details
      solo
      variant="plain"
      density="compact"
    />
    <template v-else>
      <span :style="{ fontSize }">{{ value }}</span>
    </template>
  </DataTableCell>
</template>

<script>
import DataTableCell from '@/components/userManagement/DataTableCell.vue'

export default {
  name: 'DataTableTextCell',
  components: { DataTableCell },
  props: {
    fullWidth: { type: Boolean, default: false },
    editMode: { type: Boolean, default: false },
    value: { default: '' },
    fontSize: { type: String, default: '14px' },
    type: { type: String, default: 'text' }
  },
  computed: {
    inputVal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('action', val)
      }
    }
  },
  emits: ['input']
}
</script>

<style scoped>
:deep(.v-input__slot) {
  padding: 0 !important;
}
:deep(.v-input__slot) input {
  padding: 0 !important;
}
</style>
